import React, { useEffect, useState } from "react";
import { Row, Alert, Col, Card, CardBody, Input, Label, Button, Form, Badge, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { put, get, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams, Link } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_DRIVER, UPDATE_DRIVER, UPDATE_USER, VEHICLES_SEARCH, VEHICLE_ASSIGN_DRIVER, VEHICLE_CHECK_ALLOCATED, ASSIGN_DELIVERY_TYPE_ACTIVATE
    , DRIVER_TYPE_SEARCH, UPDATE_DRIVER_DRIVER_TYPE, PARTNERS_BRANCH_SEARCH, UPDATE_DRIVER_PARTNERBRANCHES, UPLOAD_FILE } from "helpers/api_endpoints";
import Select from "react-select";
import { check } from "prettier";
import ChooseModal from "../../components/Common/ChooseModal";
import PhoneInput from 'react-country-phone-input'
import 'react-country-phone-input/lib/style.css'
import EditVehicle from "../Vehicles/EditVehicle";
import AddVehicle from "../Vehicles/AddVehicle";
import AddDriverDocument from "./AddDriverDocument";
//meta title
document.title = "Edit Driver";

const EditDriver = () => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [allowExpressChange, setAllowExpressChange] = useState(true);
    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [selectedPartnerBranches, setSelectedPartnerBranches] = useState([]);
    const [expressDeliveryTypeActivate, setExpressDeliveryTypeActivate] = useState([]);
    const [status, setStatus] = useState(1);
    const [currectStatus, setCurrentStatus] = useState(null);
    const [username, setUsername] = useState('');
    const [currentExpressOrderId, setCurrentExpressOrderId] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [walletBalance, setWalletBalance] = useState(0);
    const [password, setPassword] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [photo, setPhoto] = useState(null);
    const [userId, setUserId] = useState('');
    const [driverTypes, setDriverTypes] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [vehicleId, setVehicleId] = useState({});
    const [cvehicleId, setCVehicleId] = useState({});
    const [driverType, setDriverType] = useState([]);
    const [currentOrders, setCurrentOrders] = useState([]);
    const [vehicleTempId, setVehicleTempId] = useState(0);
    const [emirateId, setEmirateid] = useState('');
    const [driverName, setDriverName] = useState('');
    const [licenseNo, setLicenseNo] = useState('');
    const [licenseExpiry, setLicenseExpiry] = useState('');
    const [cargoEmployee, setCargoEmployee] = useState(0);
    const [errorMsg, seterrorMsg] = useState('');
    const [chooseModal, setChooseModal] = useState(false);
    const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
    const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
    const [offDays, setOffDays] = useState({range:[{from:'', to:''}], recurring:[]});
    const navigate = useNavigate();
    
    const handleWalletBalanceChange = (value) => {
        // Allow empty string
        if (value === '') {
            setWalletBalance('');
            seterrorMsg('');
            return;
        }

        const numValue = parseFloat(value);
        
        // Check if it's a valid number
        if (isNaN(numValue)) {
            seterrorMsg('Please enter a valid number');
            return;
        }
        
        // Check if it's negative
        if (numValue < 0) {
            seterrorMsg('Wallet balance cannot be negative');
            return;
        }
        
        // If all validations pass
        setWalletBalance(numValue);
        seterrorMsg('');
    };
    
	const dayOptions = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];


    useEffect(() => {
        setDriverData();
        getVehicles();
        getPartnerBranches();
        getDriverTypes();
    }, []);
    
    const getVehicles = () => {
        post(`${VEHICLES_SEARCH}`)
            .then(response =>{
                setVehicles([{value:'0',label:'None'}].concat(response.data.map(el=>{
                    return {value:el.id,label:el.id + ' - ' + el.name + ' - '+ el.plateNo}
                })));
            })
    };

    const getDriverTypes = () => {
        post(`${DRIVER_TYPE_SEARCH}`)
            .then(response =>{
                setDriverTypes(response.data);
            })
    };

    const setDriverData = () => {
        get(`${SHOW_DRIVER}/${params.id}`)
            .then(response => {
                const user = response.data.user;
                setUsername(user.name);
                console.log('response.data?.vehicle[0]?.id', response.data?.vehicle[0]?.id )
                setVehicleId(response.data?.vehicle[0]?.id);
                setEmail(user.email);
                setMobile(user.mobile);
                setDriverType(response.data.driverType);
                setEmirateid(user.emirateId);
                setPassword(user.password);
                setOldPassword(user.password);
                setAllowExpressChange(response.data.allowExpressChange);
                setCurrentExpressOrderId(response.data.currentExpressOrderId);
                setId(response.data.id);
                setPhoto(response.data.photo);
                const temp = response.data.deliveryType.filter((el,index)=>{
                    return el.id==1;
                })
                setExpressDeliveryTypeActivate(temp[0]?temp[0].DriverDeliveryType.status:'2')
                setDriverName(response.data.name);
                setCurrentOrders(response.data.currentOrders);
                setUserId(response.data.userId);
                setOffDays(response.data.offDays);
                setSelectedPartnerBranches(response.data.partnerBranch.map(el => {
                    return el.id;
                }));
                setStatus(user.status);
                setCurrentStatus(response.data.currentStatus);
                setLicenseNo(response.data.licenseNo);
                setWalletBalance(response.data.walletBalance);
                setLicenseExpiry(new Date(response.data.licenseExpiry).toISOString().split('T')[0]);
                setCargoEmployee(response.data.cargoEmployee);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // navigate('/drivers');
            })
    }

    const handleSubmit = () => {
        updateDriverData();
    }

     const getPartnerBranches = () => {
         post(`${PARTNERS_BRANCH_SEARCH}`)
             .then(response =>{
                 setPartnerBranches(response.data.map(el => {
                    return {label:el.name, value:el.id, data:el}
                 }));
             })
     };
    
    const handlePartnerBranches = (branchs) => {
        setSelectedPartnerBranches(branchs?.map(el => {
            return el.value;
        }));
    }

    const updateDriverData = () => {
        put(UPDATE_DRIVER, { id, userId, name: driverName, walletBalance, licenseNo, licenseExpiry, cargoEmployee, offDays, allowExpressChange, photo })
            .then(response => {
                if (response.code == 200) {
                    // assignExpressDeliveryType();
                    updateUserData().then(res => {console.log('res', res)
                        if(res != 'ok')
                        {
                            seterrorMsg(res);
                        }
                        else
                        {
                            updateVehicleData();
                            assignPartnerBranches();
                            navigate('/drivers', { state: { successMsg: 'Driver Updated SuccessFully' } });
                        }
                    })
                }
            })
            .catch(error => {
                console.log(error)
                seterrorMsg(error?.response?.data?.message);
            })
    }

    const assignPartnerBranches = () => {
        post(UPDATE_DRIVER_PARTNERBRANCHES, { driverId: id, partnerBranches: selectedPartnerBranches })
            .then(response => {
            })
            .catch(error => {
                console.log(error)
                seterrorMsg(error?.response?.data?.message);
            })
    }

    const updateUserData = async () => {
        const ob = { id: userId, name: username, email, mobile, emirateId, password, status };
        console.log('ob', ob);
        if(password == oldPassword)
            delete ob.password;
        return put(UPDATE_USER, ob)
            .then(response => {
                if (response.code == 200) {
                    // navigate('/drivers', { state: { successMsg: 'Driver Updated SuccessFully' } });
                    return 'ok';
                }
                else {
                    return response.message;
                }
            })
            .catch(error => {
                console.log(error)
                return error.response.data.message;
            })
    }

    const updateVehicleData = () => {
        if(vehicleId == undefined)
            return;
        post(VEHICLE_ASSIGN_DRIVER, { DriverId:id, VehicleId:vehicleId })
            .then(response => {
                if (response.code == 200) {
                    // navigate('/drivers', { state: { successMsg: 'Driver Updated SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Driver Updation Failed');
            })
    }


    const handleToggleCheckBox = (inputFunction, val) => {
        switch (inputFunction) {
            case 'setStatus':
                if (status == 1) {
                    setStatus(2);
                }
                else {
                    setStatus(1);
                }
                break;
            case 'setCargoEmployee':
                if (cargoEmployee == 1) {
                    setCargoEmployee(0);
                }
                else {
                    setCargoEmployee(1);
                }
                break;
            case 'driverType':
                updateDriverType(val);
                // dType.push()
                break;
            case 'setExpressDeliveryTypeActivate':
                if (expressDeliveryTypeActivate == 1) {
                    setExpressDeliveryTypeActivate(2);
                }
                else {
                    setExpressDeliveryTypeActivate(1);
                }
                break;
            default:
                break;
        }
    }

    const checkAllocated = (value) => {
        return post(`${VEHICLE_CHECK_ALLOCATED}`,{VehicleId:value});
    }

    const handleVehicleId = (value) => {
        checkAllocated(value).then(result => {
            if(result.data=='false')
            {
                setVehicleId(value);
            }
            else
            {
                setVehicleTempId(value);
                setChooseModal(true);
            }
        })
    }

    const handleReallocate = () => {
        setVehicleId(vehicleTempId);
        setChooseModal(false);
        
    };

    const checkDriverType = (id) => {
        const found = driverType.find(el => el.id==id);
        if(driverType != undefined && found != null)
            return true;        
        else
            return false;
    };

    const updateDriverType = (TypeId) => {
        const found = driverType.find(el => el.id==TypeId);
        put(UPDATE_DRIVER_DRIVER_TYPE, { driverId:id, driverTypeId:TypeId, op:found?1:2 })
            .then(response => {
                if (response.code == 201) {
                    if(found)
                    {
                        const temp = driverType.filter(el => el.id!=TypeId)
                        setDriverType(temp);
                    }
                    else
                    {
                        const temp = driverType;
                        temp.push({id:TypeId});
                        setDriverType(temp);
                    }
                }
            })
            .catch(error => {
                seterrorMsg('Driver Updation Failed');
            })
    };

    const assignExpressDeliveryType = () => {
        post(ASSIGN_DELIVERY_TYPE_ACTIVATE, { driverId: id, deliveryTypeId: 1, status:expressDeliveryTypeActivate })
            .then(response => {
            })
            .catch(error => {
                seterrorMsg('Driver Creation Failed');
            })
    }

    const addRange = () => {
        console.log('offDays', offDays)
        if(offDays.range == undefined)
        {
            const newOffDays = {range:[{from:'', to:''}], recurring:[]};
        }
        const newOffDays = Object.assign({}, offDays);
        newOffDays.range.push({from:'', to:''});
        setOffDays(newOffDays);
    }

    const setRangeDate = (i, type, value) => {
        const newOffDays = Object.assign({}, offDays);
        if(type == 'from')
            newOffDays.range[i].from = value;
        else if(type == 'to')
            newOffDays.range[i].to = value;
        setOffDays(newOffDays);
    }

    const setDaysOfWeek = (value) => {
        console.log('value', value)
        const newOffDays = Object.assign({}, offDays);
        newOffDays.recurring = value;
        setOffDays(newOffDays);
    }

    const handleFileUpload = (event) => {
        // setLoading(true);
        const file = event.target.files[0];
        post(`${UPLOAD_FILE}`, { file, type:"partners", fullPath:"true" }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setPhoto(data.path);
                // setLoading(false);
            })
            .catch((error) => {
            });
    }

    return (
        <React.Fragment>
            <ChooseModal
                show={chooseModal}
                onAllocateClick={handleReallocate}
                onCloseClick={() => setChooseModal(false)}
            />
                <div >
                    <Modal size="lg" isOpen={isVehicleModalOpen} toggle={() => {}}>
                        <ModalHeader >
                            <h5>Vehicle details</h5>
                            <button className="btn btn-sm btn-primary" onClick={()=>{setIsVehicleModalOpen(false)}}>Close</button>
                        </ModalHeader>
                        <ModalBody >
                            <EditVehicle  vehicleId={vehicleId??0}
                            onSuccess={()=> {setIsVehicleModalOpen(false)}}
                            onCancel={() => setIsVehicleModalOpen(false)}
                            />
                        </ModalBody>
                        <ModalFooter>
                        </ModalFooter>
                    </Modal>

                </div>

                <div >
                    <Modal size="lg" isOpen={isDocumentModalOpen} toggle={() => {}}>
                        <ModalHeader >
                            <h5>Documents details</h5>
                            <button className="btn btn-sm btn-primary" onClick={()=>{setIsDocumentModalOpen(false)}}>Close</button>
                        </ModalHeader>
                        <ModalBody >
                            <AddDriverDocument  driverId={params.id}
                            onSuccess={()=> {setIsDocumentModalOpen(false)}}
                            onCancel={() => setIsDocumentModalOpen(false)}
                            />
                        </ModalBody>
                        <ModalFooter>
                        </ModalFooter>
                    </Modal>

                </div>

            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Drivers" breadcrumbItem="Edit Driver" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                        {loading ? <Loader></Loader> :
                                            <Row>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Email</Trans></Label>
                                                    <Input
                                                        name="email"
                                                        value={email}
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        type="email"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Mobile</Trans></Label>
                                                    <PhoneInput
                                                        country={'ae'}
                                                        value={mobile}
                                                        className="form-control"
                                                        placeholder="Enter Mobile"
                                                        prefix=""
                                                        searchPlaceholder="Search"
                                                        enableSearch={true}
                                                        autocompleteSearch={true}
                                                        onChange={(e) => setMobile(e)}
                                                        required
                                                    />
                                                </div>


                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Driver Name</Trans></Label>
                                                    <Input
                                                        name="driverName"
                                                        value={driverName}
                                                        className="form-control"
                                                        placeholder="Enter Driver Name"
                                                        type="text"
                                                        onChange={(e) => {setDriverName(e.target.value);setUsername(e.target.value)}}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Wallet Balance</Trans></Label>
                                                    <Input
                                                        name="walletBalance"
                                                        value={walletBalance}
                                                        className="form-control"
                                                        placeholder="Enter Wallet Balance"
                                                        type="number"
                                                        min="0"
                                                        onChange={(e) => handleWalletBalanceChange(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Password</Trans></Label>
                                                    <Input
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                        type="password"
                                                        minLength={8}
                                                        onChange={(e) => setPassword(e.target.value)} 
                                                        
                                                    ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>License Number</Trans></Label>
                                                    <Input
                                                        name="licenseNo"
                                                        value={licenseNo}
                                                        className="form-control"
                                                        placeholder="Enter  License Number"
                                                        type="text"
                                                        onChange={(e) => setLicenseNo(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>License Expiry</Trans></Label>
                                                    <Input
                                                        name="licenseNo"
                                                        value={licenseExpiry}
                                                        className="form-control"
                                                        placeholder="Enter License Expiry"
                                                        type="date"
                                                        onChange={(e) => setLicenseExpiry(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Car / Vehicle</Trans></Label>
                                                    <Select
                                                            name="vehicleId"
                                                            value={vehicles.find(el => el.value==vehicleId)}
                                                            options={vehicles} 
                                                            className="form-control select2"
                                                            onChange={(e) => handleVehicleId(e.value)}
                                                        />
                                                    <Button type="button" color="warning" onClick={()=>{setIsVehicleModalOpen(true)}}>
                                                        <Trans>Show</Trans>
                                                    </Button>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Partner Branches</Trans></Label>
                                                    <Select
                                                            name="selectedPartnerBranches"
                                                            value={partnerBranches.filter(branch => {
                                                                return selectedPartnerBranches?.includes(branch.value)
                                                            }
                                                            )}
                                                            options={partnerBranches}
                                                            isMulti 
                                                            className="form-control select2"
                                                            onChange={(e) => handlePartnerBranches(e)}
                                                        />
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Cargo Employee</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            defaultChecked={cargoEmployee == 1}
                                                            onClick={(e) => handleToggleCheckBox('setCargoEmployee')}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Account Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck3"
                                                            defaultChecked={status == 1}
                                                            onClick={(e) => handleToggleCheckBox('setStatus')}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck3"
                                                        >
                                                            <Trans>{status==1?'Verified':'Unverified'}</Trans>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Current Orders</Trans></Label>
                                                    {
                                                        currentOrders.map( (order, i) => (
                                                            <div key={i}>
                                                                <Badge className="bg-success"><Trans>Busy</Trans></Badge>
                                                                <Link to={`/orders/edit/${order}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>{`${order}`}</Trans></button></Link>
                                                            </div>

                                                        ))
                                                    }
                                                    
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Current status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <Badge className="bg-success"><Trans>{currectStatus}</Trans></Badge>
                                                    </div>
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Allow Express Change</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <FormGroup switch>
                                                        <Input
                                                            type="switch"
                                                            size="md"
                                                            checked={allowExpressChange}
                                                            onClick={() => {
                                                                setAllowExpressChange(allowExpressChange? false : true);
                                                            }}
                                                            />
                                                        </FormGroup>

                                                    </div>
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Driver Type</Trans></Label>
                                                    {
                                                        driverTypes.map((type,index) => (

                                                        <div key={index} className="form-check form-check-end">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={type.id}
                                                                id="defaultCheck3"
                                                                defaultChecked={false}
                                                                checked={checkDriverType(type.id)}
                                                                onClick={(e) => handleToggleCheckBox('driverType', type.id)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="defaultCheck3"
                                                            >
                                                                <Trans>{type.nameTranslated}</Trans>
                                                            </label>
                                                        </div>
    
                                                        ))

                                                    }
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Driver Photo</Trans></Label>
                                                    <input className="form-control" type="file" onChange={handleFileUpload} />
                                                    <img src={photo} className="w-100" />
                                                </div>
                                                <Row>
                                                    <h3>Off Days</h3>
                                                    <div className=" col-md-6 mt-2">
                                                        <Label>
                                                            <Trans>Recurring Days</Trans>
                                                        </Label>
                                                        <Select
                                                            isMulti
                                                            options={dayOptions}
                                                            value={dayOptions.filter(option =>
                                                                offDays.recurring?.includes(option.value)
                                                            )}
                                                            onChange={selected =>
                                                            setDaysOfWeek(selected.map(item => item.value))
                                                            }
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            
                                                        />
                                                    </div>
                                                    <div className=" col-md-6 mt-2">
                                                        <h6>Range</h6>
                                                    {offDays?.range?.map((r, i) => 
                                                        (
                                                            <div key={i} className="form-group col-md-12 mt-2">
                                                                <Row>
                                                                    <div className="form-group col-md-6 mt-2">
                                                                        <Label className="form-label"><Trans>From</Trans></Label>
                                                                        <Input
                                                                            name="from"
                                                                            value={r.from}
                                                                            className="form-control"
                                                                            placeholder=""
                                                                            type="date"
                                                                            onChange={(e) => setRangeDate(i, 'from', e.target.value)}
                                                                             ></Input>
                                                                    </div>
                                                                    <div className="form-group col-md-6 mt-2">
                                                                        <Label className="form-label"><Trans>To</Trans></Label>
                                                                        <Input
                                                                            name="to"
                                                                            value={r.to}
                                                                            className="form-control"
                                                                            placeholder=""
                                                                            type="date"
                                                                            onChange={(e) => setRangeDate(i, 'to', e.target.value)}
                                                                             ></Input>
                                                                    </div>
                                                                </Row>
                                                            </div>
                                                        )

                                                    )}
                                                            <div className="mt-4">
                                                                <Button type="button" color="danger" onClick={addRange}>
                                                                    <Trans>Add</Trans>
                                                                </Button>
                                                            </div>
                                                    </div>
                                                    <div className="mt-4">
                                                        <Button type="button" color="warning" onClick={()=>{setIsDocumentModalOpen(true)}}>
                                                            <Trans>Documents</Trans>
                                                        </Button>
                                                    </div>
                                                </Row>
                                                <div className="mt-4">
                                                    <Button type="submit" color="primary">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditDriver
